import React from 'react';
import { Grid } from 'style';
import { DataStoreService } from 'utils';
import ListComponent, { ItemComponent, ListWrapper } from '../common/lists/lists.component';
import ThoughtCardComponent from './subcomponents/thoughtCard.component';

class ThoughtsList extends ListComponent {
  constructor(props) {
    super(props);

    this.state = {
      thoughts: null
    };
  }

  componentDidMount() {
    this.setState(() => ({
      thoughts: DataStoreService.getThoughts(),
    }));
  }

  render() {
    const {
      thoughts
    } = this.state;
    return thoughts ? (
      <Grid.Overflow id="ThoughtsList">
        <ListWrapper id="wrapper"
          margin={`${100 / 18 * .5}`} padding={100 / 18 * 2}> {
            thoughts.edges.map((data, i) => (<ItemComponent itemsPerRow={3} align={'baseline'}
              key={
                data.node.slug
              }
              onChange={
                this.onVisible
              } >
              <ThoughtCardComponent even={i % 2 == 0} {...data.node} /> </ItemComponent>
            ))
          }
          <ItemComponent itemsPerRow={3} />
          <ItemComponent itemsPerRow={3} />
        </ListWrapper>
      </Grid.Overflow>
    ) : (<div />
      );
  }
}

export default ThoughtsList;
